export default __webpack_public_path__ + "static/media/chb.10e7a341.jpg";